import { useCallback, useState } from 'react';

type UseToggleReturnType = [boolean, () => void, (value: boolean) => void];

export const useToggle = (
	initValue: boolean,
	callback?: () => void
): UseToggleReturnType => {
	const [state, setValue] = useState(initValue);

	const onToggle = useCallback(() => {
		setValue((prevValue) => !prevValue);
		callback?.();
	}, [callback]);

	return [state, onToggle, setValue];
};
